import React from "react";
import GameController from "../components/GameController";
import "./Home.css";

const Tab1: React.FC = () => {
  return <GameController />;
};

export default Tab1;
